import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '@ant-design/icons';
import { logoutUser } from '../../core/user/userApi';
import './logout.scss';
import { AppDispatch, CombinedStates } from '../../core/types';
import { LogoutIcon } from '../Elements/CustomSVGIcon';

const Logout = () => {
    const dispatch = useDispatch<AppDispatch>();
    const {
        isFetching,
    } = useSelector((state:CombinedStates) => state.user);

    const handleLogout = (e:React.MouseEvent) => {
        e.preventDefault();
        dispatch(logoutUser());
    };

    return (
        <span
            className={`logout-link ${isFetching ? 'loading' : ''}`}
            onClick={handleLogout}
            style={{ cursor: isFetching ? 'not-allowed' : 'pointer' }}>
            <Icon
                component={LogoutIcon as React.ForwardRefExoticComponent<unknown>}
                className="logout-icon" />
            <span className="logout-text">Logout</span>
        </span>
    );
};

export default Logout;
